import React, { useEffect, useRef, useState } from "react";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
  FetchOwnerHorsesDropDownthunk,
} from "../Redux/OwnerProfile/OwnerProfileAction";
import {
  FetchCreateEmbryoOocyteTransferPermitServiceRequestthunk,
  FetchGetServiceDefinitionByIdthunk,
  FetchGetServicesRequestByIdthunk,
  FetchIsHaseRequestEmbryoOocyteTransferPermitthunk,
  FetchUpdateEmbryoOocyteTransferPermitServiceRequestthunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
  resetGetServicesRequestByIdData,
  resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { formatDate } from "../helper/formatDate";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import { isLessThanUndefinedYearOld } from "../helper/isLessThanUndefinedYearOld";
import EahsForm from "../components/EahsForm";
import PillBtn from "../components/PillBtn";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import SubmitAndPay from "../components/servicesButtons/SubmitAndPay";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import { eFormButtonsContainer, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";

export default function RequestEmbryoOocyteTransferPermit() {
  //env
  const UMBRACOURL = process.env.REACT_APP_UMBRACO;
  // const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
  const BaseURL = process.env.REACT_APP_BASE_URL;

  //selector
  const { currentLanguage } = useSelector((state) => state.studBookSlice);

  const { ownerHorsesDropDownData } = useSelector(
    (state) => state.ownerProfileSlice
  );

  const {
    toasterMessageServicesRequests,
    servicesRequestsLoading,
    getServicesRequestByIdData,
    getServiceDefinitionByIdData,
    isHaseRequestEmbryoOocyteTransferPermitData,
    createEmbryoOocyteTransferPermitServiceRequestData
  } = useSelector((state) => state.servicesRequestsSlice);

  const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
  const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

  const dispatch = useDispatch();

  const { translate } = useTranslate();

  const navigate = useNavigate();

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const serviceId = searchParams.has("serviceId")
    ? searchParams.get("serviceId")
    : null;

  const id = searchParams.has("id") ? searchParams.get("id") : null;

  const action = searchParams.has("action") ? searchParams.get("action") : null;
  const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

  //state
  const [formModel, setFormModel] = useState({
    id: "",
    horse: "",
    horseDrop: {
      label: translate("web.horse", "Horse"),
      value: null,
    },

    origin: "",
    gender: "",
    color: "",
    birthDate: "",
    sire: "",
    dam: "",
    breeder: "",

    eventName: "",
    comment: "",
    ownerComment: "",
    referenceNumber: "",
    requestsType: "",
    paymentStatus: "",

    isHaseRequestEmbryoOocyteTransferPermit: false,
    embryoOocyteTransferPermitId: null,
  });

  const [errorHorse, setErrorHorse] = useState("none");

  const horseRef = useRef(null);

  const _isOnlinePayment = useRef("");
  const [checkedItems, setCheckedItems] = useState({});

  // const [checkedItems, setCheckedItems] = useState({
  //   option1: false,
  //   option2: false,
  //   option3: false,
  //   option4: false,
  //   //option5: false,
  //   option6: false,
  //   option7: false,
  // });

  const [profile, setProfile] = useState({
    label:
      !!userProfile &&
      userProfile?.ownerRegisterNo +
      " - " +
      userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
    value: localStorage.getItem("EAHSUserID"),
  });
  const subAccountId = localStorage.getItem("currentSubAccountId");

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
    }),
  };

  //function
  const handleFormChange = (e, input) => {
    if (input === "horse") {
      let horse = ownerHorsesDropDownData.filter((item) => item.id == e.value);

      if (e.value !== "") {
        let params = {
          horseId: e.value,
          serviceDefinitionId: serviceId,
          ownerId: getUserID(),
        }
        dispatch(FetchIsHaseRequestEmbryoOocyteTransferPermitthunk(params));
      }

      setFormModel({
        ...formModel,
        horseDrop: e,
        horse: e.value,
        gender: horse[0]?.gender ?? "",
        color: horse[0]?.color ?? "",
        birthDate: horse[0]?.birthDateObject ?? "",
        sire: horse[0]?.sire ?? "",
        dam: horse[0]?.dam ?? "",
        origin: horse[0]?.origin ?? "",
        breeder: horse[0]?.breeder ?? "",
      });
    } else {
      setFormModel({
        ...formModel,
        [e.target.name]: e.target.value,
      });
    }
  };

  const validInputs = () => {
    let valid = true;

    if (
      formModel.horse === ""
    ) {
      setErrorHorse("");
      valid = false;

      horseRef?.current?.focus();
      return;
    }
    else {
      setErrorHorse("none");
    }

    //terms
    if (Object.values(checkedItems).length > 0) {  // Optional safe check
      const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

      if (!allTermsChecked && action == null) {
        toast.error(
          translate("web.pleaseCheckAllTerms", "Please Check All Terms")
        );
        valid = false;
      }
    }

    // if (
    //   !checkedItems.option1 ||
    //   !checkedItems.option2 ||
    //   !checkedItems.option3 ||
    //   !checkedItems.option6 ||
    //   !checkedItems.option7

    //   //||(!checkedItems.option4 && isLessThanUndefinedYearOld(new Date(formModel.birthDate), 3))
    //   //||(!checkedItems.option5 && formModel.isHaseRequestEmbryoOocyteTransferPermit)
    // ) {
    //   toast.error(
    //     translate("web.pleaseCheckAllTerms", "Please Check All Terms")
    //   );
    //   valid = false;
    // }

    if (isLessThanUndefinedYearOld(new Date(formModel.birthDate), 3)) {
      toast.error(
        translate("web.embryoOocyteTransferPermitNote3", "embryo Oocyte Transfer Permit Note3")
      );
      valid = false;
    }

    if (Object.keys(isHaseRequestEmbryoOocyteTransferPermitData).length > 0) {
      toast.error(
        currentLanguage === "en" ? `You cannot submit this request for this mare because there is a valid embryo/oocyte transfer permit Ref.No: ${isHaseRequestEmbryoOocyteTransferPermitData.referenceNumber} from date: ${isHaseRequestEmbryoOocyteTransferPermitData.fromDate} to date: ${isHaseRequestEmbryoOocyteTransferPermitData.toDate}.` :
          `لايمكنك تقديم طلب لهذا الفرس بسبب وجود تصريح نقل أجنة/بويضات ساري المفعول برقم مرجعي: ${isHaseRequestEmbryoOocyteTransferPermitData.referenceNumber} من تاريخ: ${isHaseRequestEmbryoOocyteTransferPermitData.fromDate} الى تاريخ: ${isHaseRequestEmbryoOocyteTransferPermitData.toDate}`
        //translate("web.embryoOocyteTransferPermitNote4", "Embryo Oocyte Transfer Permit Note 4")
      );

      valid = false;
    }

    return valid;
  }

  const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
    if (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack") {
      const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

      const encodeURI = encodeURIComponent(returnUrl);

      window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=8&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
    }
    else {
      if (
        validInputs()
      ) {
        _isOnlinePayment.current = isOnlinePayment;

        let params = {
          id: id,
          serviceDefinitionId: serviceId,
          //date: new Date().toLocaleDateString(),
          status: status,
          eventName: formModel.eventName,
          horse: formModel.horse,
          ownerId: getUserID(),
          createdBy: localStorage.getItem("EAHSUserID"),
          ownerComment: formModel.ownerComment,
          buttonAction: buttonAction
        };

        if (action == null) {
          dispatch(FetchCreateEmbryoOocyteTransferPermitServiceRequestthunk(params));
        } else if (action === "edit" || formModel.eventName === "SentBack") {
          dispatch(FetchUpdateEmbryoOocyteTransferPermitServiceRequestthunk(params));
        }
      }
    }
  };

  const handelSelectedAccountChange = async (element) => {
    let params = {
      ownerId: element.value,
      skip: 0,
      take: 1000,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: "",
      sortBy: "-1",
      isLoadExported: true,
      serviceDefinitionId: serviceId
    };
    dispatch(FetchOwnerHorsesDropDownthunk(params));

    setProfile(element);

    setFormModel({
      ...formModel,
      horse: "",
      horseDrop: {
        label: translate("web.horse", "Horse"),
        value: null,
      },
      gender: "",
      color: "",
      birthDate: "",
      sire: "",
      dam: "",
      origin: "",
      breeder: "",
    });
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setCheckedItems((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  function CheckIfAgentHasPermission() {
    const AgentHasPermission = userProfile.subAccounts
      .filter((x) => x.value == subAccountId)[0]
      .ownersPermissionsList.some(
        (x) =>
          x.permissionName === "EmbryoTransfer" || x.permissionName === "All"
      );
    return AgentHasPermission;
  }

  // const getUserID = () => {
  //   const userID =
  //     !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
  //   return userID;
  // };

  const getUserID = () => {
    let userID =
      !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
    if ((action == null || action === "edit") == false) {
      userID = subAccountId;
    }
    return userID;
  };
  const getSelectedAccountName = () => {
    const selectAccount = userProfile.subAccounts.filter(
      (x) => x.value == subAccountId
    );

    if (selectAccount.length > 0) {
      return selectAccount[0];
    }
    else {
      return false;
    }
  };

  const dismissAll = () => toast.dismiss();

  //Effect
  useEffect(() => {
    if (id != null) {
      let params = {
        language: currentLanguage,
        id: id,
        ownerId: ownerId
      };

      dispatch(FetchGetServicesRequestByIdthunk(params));
    }

    return () => {
      dispatch(resetGetServicesRequestByIdData());
    };
  }, []);

  useEffect(() => {
    if (!!userProfile && userProfile?.haveProfileSignture != true) {
      toast.error(
        translate(
          "web.completeOwnerProfileData",
          "Please complete the personal data of the profile."
        )
      );

      setTimeout(() => {
        navigate("/profile");
      }, 3000);
    }

    if (!!userProfile && userProfile?.accountType === "Agent") {
      if (userProfile.id == subAccountId) {
        navigate("/403-Not-Authrized");
      }

      if (!CheckIfAgentHasPermission()) {
        navigate("/403-Not-Authrized");
      }
    }

    let params = {
      ownerId: getUserID(),
      skip: 0,
      take: 1000,
      langauge: currentLanguage,
      horseTypeFilter: "1",
      searchValue: "",
      sortBy: "-1",
      isLoadExported: true,
      serviceDefinitionId: serviceId
    };
    dispatch(FetchOwnerHorsesDropDownthunk(params));

    let subOwnerProfilesParams = {
      id: getUserID(),
      langauge: currentLanguage,
    };
    dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

    dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));
  }, [currentLanguage]);

  useEffect(() => {
    if (getServicesRequestByIdData != null &&
      Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
    ) {
      setFormModel({
        ...formModel,
        eventName: getServicesRequestByIdData.eventName,
        comment: getServicesRequestByIdData.comment,
        requestsType: getServicesRequestByIdData.requestsType,
        paymentStatus: getServicesRequestByIdData.paymentStatus,
        referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,
        embryoOocyteTransferPermitId: getServicesRequestByIdData.embryoOocyteTransferPermit.embryoOocyteTransferPermitId,

        horse: getServicesRequestByIdData.embryoOocyteTransferPermit.horse,
        horseDrop: {
          label:
            getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.registrationNumber +
            " - " +
            getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.nameEn,
          value: getServicesRequestByIdData.embryoOocyteTransferPermit.horse,
        },
        origin: getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.exportCountry,
        gender: getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.gender,
        color:
          currentLanguage == "en"
            ? getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.horseColor
              .nameEn
            : getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.horseColor
              .nameAr,
        birthDate:
          getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.birthDate,
        sire: getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.sireNameEn,
        dam: getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.damNameEn,
        breeder: getServicesRequestByIdData.embryoOocyteTransferPermit.horseVM.breeder,
        ownerComment: getServicesRequestByIdData.embryoOocyteTransferPermit.ownerComment != null ? getServicesRequestByIdData.embryoOocyteTransferPermit.ownerComment : "",
      });

      //another owner
      if (
        getServicesRequestByIdData.embryoOocyteTransferPermit.ownerId !==
        getServicesRequestByIdData.embryoOocyteTransferPermit.createdBy &&
        subOwnerProfilesByIdData.length > 0 &&
        getServicesRequestByIdData.requestsType !== "BackOffice"
      ) {
        let params = {
          ownerId: getServicesRequestByIdData.embryoOocyteTransferPermit.ownerId,
          skip: 0,
          take: 1000,
          langauge: currentLanguage,
          horseTypeFilter: "1",
          searchValue: "",
          sortBy: "-1",
          isLoadExported: true,
          serviceDefinitionId: serviceId
        };
        dispatch(FetchOwnerHorsesDropDownthunk(params));

        //update profile
        setProfile({
          label:
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.embryoOocyteTransferPermit.ownerId
            )[0].registerNo +
            " - " +
            subOwnerProfilesByIdData.filter(
              (item) =>
                item.value ==
                getServicesRequestByIdData.embryoOocyteTransferPermit.ownerId
            )[0][`text${currentLanguage === "en" ? "" : "Ar"}`],
          value: subOwnerProfilesByIdData.filter(
            (item) =>
              item.value == getServicesRequestByIdData.embryoOocyteTransferPermit.ownerId
          )[0].value,
        });
      }
    }
  }, [
    getServicesRequestByIdData,
  ]);

  useEffect(() => {
    if (
      toasterMessageServicesRequests != null &&
      toasterMessageServicesRequests === "save"
    ) {
      if (_isOnlinePayment.current !== "") {
        toast.success(
          translate(
            "web.yourRequestHasSubmittedSuccessfully",
            "Your Request Has Submitted Successfully"
          )
        );
      } else {
        toast.success(
          translate("web.dataSavedSuccessfully", "Data Saved Successfully")
        );
      }

      dispatch(resetToasterMessageServicesRequests());

      setTimeout(() => {
        if (_isOnlinePayment.current !== "") {
          const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${createEmbryoOocyteTransferPermitServiceRequestData.id}`;

          const encodeURI = encodeURIComponent(returnUrl);

          window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${createEmbryoOocyteTransferPermitServiceRequestData.id}&paymentType=8&userId=${localStorage.getItem(
            "EAHSUserID"
          )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
        } else {
          navigate(`/profile?activeTab=${"e_services"}`);
        }
      }, 1000);
    }

    //error
    else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
      if (toasterMessageServicesRequests !== "errorServiceDetails") {

        toast.error(
          translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
        );

        dispatch(resetToasterMessageServicesRequests());
      }

      else if (toasterMessageServicesRequests === "errorServiceDetails") {
        toast.error(
          translate("web.createServiceRequestFailed", "Service Request Failed")
        );

        dispatch(resetToasterMessageServicesRequests());

        setTimeout(() => {
          navigate(`/profile?activeTab=${"e_services"}`);
        }, 1000);
      }
    }
  }, [toasterMessageServicesRequests]);

  useEffect(() => {
    if (getServiceDefinitionByIdData?.termsList) {
      const initialState = {};
      getServiceDefinitionByIdData.termsList.forEach((_, index) => {
        initialState[`option${index + 1}`] = false;
      });
      setCheckedItems(initialState);
    }
  }, [getServiceDefinitionByIdData?.termsList]);

  //consoles
  console.log(formModel)
  console.log("profile", userProfile);

  return (
    <>
      {/* loading div */}
      <div
        className={`page-overlay text-center ${servicesRequestsLoading
          ? "classdisplay"
          : "classnotdisplay"
          }`}
      >
        <div className="loaderDiv">
          <Loader />
        </div>
      </div>
      {/* toast */}
      <ToastContainer
        position="top-right"
        onClick={dismissAll}
        theme="colored"
        autoClose={5000}
      />
      {/* content page */}
      <div className={serviceRequestHeadContainer}>
        {/* Embryo Oocyte Transfer Permit title */}
        <h2 className={serviceRequestTitle}>
          {currentLanguage === "en"
            ? getServiceDefinitionByIdData.nameEn
            : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
        </h2>
        {/* Selected Account */}
        {subOwnerProfilesByIdData.length > 0 &&
          (action == null || action === "edit") &&
          (
            <div className={userDropDown}>
              {!!userProfile && userProfile?.accountType !== "Agent" ? (
                <>
                  <NetaqInput
                    label={translate("web.selectedAccount", "Selected Account")}
                    name="selectAccount"
                    type="select"
                    listSelect={[
                      ...(!!subOwnerProfilesByIdData &&
                        !!subOwnerProfilesByIdData.length > 0 &&
                        subOwnerProfilesByIdData.map((a) => ({
                          label:
                            a?.registerNo +
                            " - " +
                            a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                          value: a.value,
                        }))),
                    ]}
                    value={profile}
                    onChange={(e) => {
                      handelSelectedAccountChange(e);
                    }}
                    placeholder={localStorage.getItem("EAHSUserFullName")}
                  />
                </>
              ) : (
                <>
                  {getSelectedAccountName()?.registerNo +
                    " - " +
                    getSelectedAccountName()[
                    `text${currentLanguage === "en" ? "" : "Ar"}`
                    ]}
                </>
              )}
            </div>
          )}
      </div>

      {/* mare details */}
      <EahsForm className={'mb-main'} isSectionTitle ish3 title={translate("web.mareDetails", "Mare Details")}>
        <div className={eformInput}>
          <label>
            {translate("web.horse", "Horse")}
            <i className=" colorred"> *</i>
          </label>
          <Select
            options={[
              {
                label: translate("web.horse", "Horse"),
                value: "",
              },
              ...(!!ownerHorsesDropDownData &&
                ownerHorsesDropDownData.filter(q => q.gender === "Mare").map((a) => ({
                  label: a.registerNumber + " - " + a.name,
                  value: a.id,
                }))),
            ]}
            value={formModel.horseDrop}
            onChange={(e) => handleFormChange(e, "horse")}
            placeholder={translate("web.horse", "Horse")}
            name={"horse"}
            isSearchable
            noOptionsMessage={() =>
              translate("web.noOptions", "No Options")
            }
            autoFocus={true}
            key={"horse"}
            isDisabled={
              ((action === "approve" && formModel.eventName !== "SentBack") || action === "view") ?
                true
                : false
            }
            ref={horseRef}
          />
          <span style={{ color: "red", display: errorHorse }} className="errorHorseMareReg">
            {translate("web.requiredField", "Required Field")}
          </span>
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.origin", "Origin")}
            name={"origin"}
            type={"text"}
            disabled={true}
            value={formModel.origin}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.breeder", "Breeder")}
            name={"breeder"}
            type={"text"}
            disabled={true}
            value={formModel.breeder}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.gender", "Gender")}
            name={"gender"}
            type={"text"}
            disabled={true}
            value={translate(
              `web.${formModel.gender?.toLowerCase()}`,
              formModel.gender
            )}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.color", "Color")}
            name={"color"}
            type={"text"}
            disabled={true}
            value={formModel.color}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.birthDate", "Birth Date")}
            name={"birthDate"}
            type={"renderDate"}
            disabled={true}
            value={
              formModel.birthDate
            }
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.sire", "Sire")}
            name={"sire"}
            type={"text"}
            disabled={true}
            value={formModel.sire}
          />
        </div>

        <div className={eformInput}>
          <NetaqInput
            label={translate("web.dam", "Dam")}
            name={"dam"}
            type={"text"}
            disabled={true}
            value={formModel.dam}
          />
        </div>
      </EahsForm>
      {/* Comments */}
      {(!!formModel.comment || !!formModel.ownerComment) && (
        <EahsForm title={translate("web.comments", "Comments")}>
          {/* eahs Comment */}
          {!!formModel.comment && (
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.eahsComments", "EAHS Comments")}
                name={"adminComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.comment}
                disabled={true}
              />
            </div>
          )}

          {(!!formModel.ownerComment || formModel.eventName === "SentBack") && (
            // owner Comment 
            <div className={eformInput}>
              <NetaqInput
                label={translate("web.ownerComment", "Owner Comment")}
                name={"ownerComment"}
                type={"textarea"}
                maxchars={1150}
                value={formModel.ownerComment}
                onChange={handleFormChange}
                disabled={formModel.eventName !== "SentBack" ? true : false}
              />
            </div>
          )}
        </EahsForm>
      )}

      <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
        {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
          return (
            <div className={eformTerms} key={index}>
              <NetaqInput
                type={"checkbox"}
                label={item}
                name={`option${index + 1}`}
                checked={checkedItems[`option${index + 1}`] || action != null}
                onChange={handleCheckboxChange}
                disabled={formModel.eventName !== ""}
              />
            </div>
          );
        })}
      </EahsForm>

      {/* <EahsForm ish3 isSectionTitle className={'mb-main'} title={translate("web.terms", "Terms")}>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.embryoOocyteTransferPermitNote1",
              "Embryo Oocyte Transfer Permit Note 1"
            )}
            name="option2"
            checked={checkedItems.option2}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.embryoOocyteTransferPermitNote2",
              "Embryo Oocyte Transfer Permit Note 2"
            )}
            name="option3"
            checked={checkedItems.option3}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        {
          // isLessThanUndefinedYearOld(new Date(formModel.birthDate), 3) &&

          // <div className="col-md-12 col-sm-12 rtl p0">
          //   <NetaqInput
          //     type={"checkbox"}
          //     label={translate(
          //       "web.embryoOocyteTransferPermitNote3",
          //       "Embryo Oocyte Transfer Permit Note 3"
          //     )}
          //     name="option4"
          //     checked={checkedItems.option4}
          //     onChange={handleCheckboxChange}
          //     disabled={formModel.eventName === "" ? false : true}
          //   />
          // </div>
        }

        {
          // formModel.isHaseRequestEmbryoOocyteTransferPermit &&
          // <div className="col-md-12 col-sm-12 rtl p0">
          //   <NetaqInput
          //     type={"checkbox"}
          //     label={translate(
          //       "web.embryoOocyteTransferPermitNote4",
          //       "Embryo Oocyte Transfer Permit Note 4"
          //     )}
          //     name="option5"
          //     checked={checkedItems.option5}
          //     onChange={handleCheckboxChange}
          //     disabled={formModel.eventName === "" ? false : true}
          //   />
          // </div>
        }
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.embryoOocyteTransferPermitNote5",
              "Embryo Oocyte Transfer Permit Note 5"
            )}
            name="option6"
            checked={checkedItems.option6}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.embryoOocyteTransferPermitNote6",
              "Embryo Oocyte Transfer Permit Note 6"
            )}
            name="option7"
            checked={checkedItems.option7}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
        <div className={eformTerms}>
          <NetaqInput
            type={"checkbox"}
            label={translate(
              "web.ServiceGeneralNote",
              "Service General Note"
            )}
            name="option1"
            checked={checkedItems.option1}
            onChange={handleCheckboxChange}
            disabled={formModel.eventName === "" ? false : true}
          />
        </div>
      </EahsForm> */}

      {/* buttons */}
      <div className={eFormButtonsContainer}>
        {/* draft/pay/submit btn */}
        {
          ((action == null || action === "edit") ||
            (action === "approve" && (formModel.eventName === "SentBack" || (formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice")))) && (
            <>
              {/* draft */}
              {(formModel.eventName === "" || formModel.eventName === "Draft") &&
                <DraftBtn
                  onClick={() => handelFormSubmit("Draft", "", "Draft")}
                  isDisabled={
                    formModel.eventName === "" ||
                      formModel.eventName === "Draft"
                      ? false
                      : true
                  } />
              }

              {/* pay later */}
              {userProfile?.participateWithoutPayment == true && formModel.eventName !== "SentBack" && action !== "view" && (
                <ApproveAndPayLaterBtn
                  selectedAccountId={profile?.value}
                  isApprove={false} onClick={() =>
                    handelFormSubmit("Draft", "no", "Pay")
                  }
                  isDisabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  } />

              )}

              {/* pay */}
              {formModel.eventName !== "SentBack" && action !== "view" &&
                <SubmitAndPay
                  selectedAccountId={profile?.value}
                  onClick={() =>
                    handelFormSubmit("Draft", "yes", "Pay")
                  }
                  isDisabled={
                    formModel.eventName === "SentBack"
                      ? true
                      : false
                  } />

              }

              {/* submit */}
              {action === "approve" && formModel.eventName === "SentBack" &&
                <SubmitServiceBtn onClick={() =>
                  handelFormSubmit("Submit", "", "Submit")
                  //handelFormSubmit("PendingReview", "")
                }
                  isDisabled={
                    action === "approve" && formModel.eventName === "SentBack"
                      ? false
                      : true
                  } />
              }
            </>
          )
        }
      </div>
    </>
  );
}
